import {Select} from '@mantine/core';
import {
  MdCheck,
  MdClose,
  MdDoDisturb,
  MdOutlineUnfoldMore,
  MdSchedule,
} from 'react-icons/md';
import {COLOR_WHITE} from '../../../../../../config/constants/colorCodes';
import {
  PROGRESS_RESULT_OPTIONS,
  PROGRESS_RESULT_VALUES,
} from '../../../../../../core/entities/entryManagements/constants';
import {cn} from '../../../../../../lib/classname';

type Props = {
  value: string;
  onChange: (value: string) => void;
};

export const SelectStepResult: React.FC<Props> = ({value, onChange}) => {
  const icon = (value: string) => {
    switch (value) {
      case PROGRESS_RESULT_VALUES.pending:
        return <MdSchedule className="text-white text-base" />;
      case PROGRESS_RESULT_VALUES.accepted:
      case PROGRESS_RESULT_VALUES.completed:
        return <MdCheck className="text-white text-base" />;
      case PROGRESS_RESULT_VALUES.rejected:
        return <MdClose className="text-white text-base" />;
      case PROGRESS_RESULT_VALUES.declined:
        return <MdDoDisturb className="text-white text-base" />;
      default:
        return undefined;
    }
  };

  return (
    <Select
      data={PROGRESS_RESULT_OPTIONS}
      value={value}
      icon={icon(value)}
      rightSection={<MdOutlineUnfoldMore className="text-white text-xs" />}
      rightSectionWidth={12}
      onChange={onChange}
      variant="unstyled"
      withinPortal
      className={cn('flex h-28 items-center rounded-4', {
        'bg-sub': value === PROGRESS_RESULT_VALUES.pending,
        'bg-success':
          value === PROGRESS_RESULT_VALUES.accepted ||
          value === PROGRESS_RESULT_VALUES.completed,
        'bg-black-2':
          value === PROGRESS_RESULT_VALUES.rejected ||
          value === PROGRESS_RESULT_VALUES.declined,
        'bg-primary-3': value === '',
      })}
      classNames={{
        input: cn('text-center', {
          '!pl-16': value !== '',
        }),
      }}
      styles={{
        input: {
          color: COLOR_WHITE,
          fontSize: 11,
          width: 96,
        },
        icon: {
          width: 16,
          left: 8,
        },
        rightSection: {
          right: 4,
        },
        item: {
          whiteSpace: 'nowrap',
          fontSize: 11,
        },
        dropdown: {
          minWidth: 110,
        },
      }}
    />
  );
};
